module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-341-min.9e31f0fe.jpg";